/* E for Education theme — small, dependency-free helpers */
(function () {
  // Quantity steppers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var step = btn.getAttribute('data-qty') === 'plus' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Product gallery thumbnails
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var root = thumb.closest('[data-product]');
    var main = root.querySelector('[data-main-image]');
    main.src = thumb.getAttribute('data-thumb');
    main.srcset = '';
    root.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
    thumb.setAttribute('aria-current', 'true');
  });

  // Variant picker: keeps price, button state and URL in sync
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var json = root.querySelector('[data-variants]');
    var select = root.querySelector('[data-variant-select]');
    if (!json || !select) return;
    var variants = JSON.parse(json.textContent);
    var price = root.querySelector('[data-price]');
    var button = root.querySelector('[data-add]');
    var main = root.querySelector('[data-main-image]');
    var fmt = root.getAttribute('data-money-format') || '${{amount}}';

    function money(cents) {
      var amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    }

    select.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === select.value; });
      if (!v) return;
      if (price) {
        price.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
      }
      if (button) {
        button.disabled = !v.available;
        button.textContent = v.available ? button.getAttribute('data-label') : button.getAttribute('data-soldout');
      }
      if (main && v.featured_image) { main.src = v.featured_image.src; main.srcset = ''; }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  });
})();
